import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/downloadManualInvoices', request, null, {responseType: 'arraybuffer'})
}
export {get}
